export default __webpack_public_path__ + "static/media/80.855f70a6.jpg";